module.exports = __webpack_public_path__ + "02_medium_gold.619d471b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_medium_gold.png
// module id = ftjI
// module chunks = 0